import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaPensionistasADMRHInicio: [],
    buscaConsultaPensionistasADMRHErro: ['erro'],
    buscaConsultaPensionistasADMRHSucesso: ['consultaPensionistasADMRH'],
    limpar: [],
    setConsultaPensionistasADMRHEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaPensionistasADMRH = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaPensionistasADMRHInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultarQuadrosMembros(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaPensionistasADMRHSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaPensionistasADMRHErro(error)))
    }
}

const buscaConsultaPensionistasADMRHInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaPensionistasADMRHErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaPensionistasADMRHSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaPensionistasADMRH.resultado,
        dataSincronizacaoDados: action.consultaPensionistasADMRH.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaPensionistasADMRHEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_PENSIONISTAS_ADMRH_INICIO]: buscaConsultaPensionistasADMRHInicio,
    [Types.BUSCA_CONSULTA_PENSIONISTAS_ADMRH_ERRO]: buscaConsultaPensionistasADMRHErro,
    [Types.BUSCA_CONSULTA_PENSIONISTAS_ADMRH_SUCESSO]: buscaConsultaPensionistasADMRHSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_PENSIONISTAS_ADMRH_ESTADO_DT]: setConsultaPensionistasADMRHEstadoDT,
})
